<template>
  <div>
    <slot v-if="isLoading && $slots.skeleton" name="skeleton" />

    <div
      v-else-if="isLoading && !$slots.skeleton"
      class="loading"
      :class="{ 'loading-large': !small, 'loading-with-text': loadingText }"
    >
      <p v-if="loadingText && !longLoadingText" class="loading-text">{{ loadingText }}</p>

      <p v-if="longLoadingText && showLongLoadingText" class="loading-text" :class="longLoadingTextClass">
        {{ longLoadingText }}
      </p>
    </div>

    <slot v-else></slot>

    <template v-if="$slots.timeout && isConsideredTimeout">
      <slot name="timeout" />
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'UtilLoader',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    loadingText: String,
    small: Boolean,
    showLongLoadingText: {
      type: Boolean,
      default: true
    },
    longLoadingTextClass: String
  },
  data() {
    return {
      timeStart: 0,
      timer: null,
      longLoadingText: null,
      isConsideredTimeout: false
    }
  },
  watch: {
    isLoading(loading) {
      if (loading) {
        this.startSlowLoadingTimer()
      } else {
        this.stopSlowLoadingTimer()
      }
    }
  },
  mounted() {
    if (this.isLoading) {
      this.startSlowLoadingTimer()
    }
  },
  destroyed() {
    this.stopSlowLoadingTimer()
  },
  methods: {
    startSlowLoadingTimer() {
      if (!this.timer) {
        this.timeStart = dayjs()

        this.timer = setInterval(() => {
          let timeNow = dayjs()

          const secondsTimeDifference = timeNow.diff(this.timeStart, 'second')

          if (secondsTimeDifference > 5) {
            this.longLoadingText = 'Still loading...'
          }

          if (secondsTimeDifference > 15) {
            this.longLoadingText = 'Internet connectivity issues?'
          }

          if (secondsTimeDifference > 25) {
            this.longLoadingText = 'This is taking too long, try reloading the app or contact us to investigate.'
            this.isConsideredTimeout = true
          }
        }, 1000)
      }
    },

    stopSlowLoadingTimer() {
      clearInterval(this.timer)
      this.longLoadingText = null
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-text {
  @apply mt-12 text-center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
</style>
